// @flow
import common from 'modules/Common/lang/fr'
import landing from 'modules/Authenticate/lang/fr'
import admin from 'modules/Admin/lang/fr'

export default {
  common,
  landing,
  admin
}
